import { render, staticRenderFns } from "./PefPcrInactiveTable.vue?vue&type=template&id=29bd7c37&scoped=true&"
import script from "./PefPcrInactiveTable.vue?vue&type=script&lang=js&"
export * from "./PefPcrInactiveTable.vue?vue&type=script&lang=js&"
import style0 from "./PefPcrInactiveTable.vue?vue&type=style&index=0&id=29bd7c37&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bd7c37",
  null
  
)

export default component.exports